import get from 'lodash/get';
import ProductTestingState from './state';
import { ProductTestingTypes } from './types';

const INITIAL_STATE = new ProductTestingState();

export default function productTestingReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    //-------------------------------------------------
    // GET_COUNTRIES_LIST
    case ProductTestingTypes.GET_COUNTRIES_LIST.LOADING:
      return {
        ...state,
        countriesList: {
          ...state.countriesList,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_COUNTRIES_LIST.SUCCESS:
      return {
        ...state,
        countriesList: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.GET_COUNTRIES_LIST.ERROR:
      return {
        ...state,
        countriesList: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_JOB_LIST
    case ProductTestingTypes.GET_JOB_LIST.LOADING:
      return {
        ...state,
        jobList: {
          ...state.jobList,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_JOB_LIST.SUCCESS:
      return {
        ...state,
        jobList: {
          loading: false,
          data: action.payload,
          total: action.total,
          error: null,
        },
      };
    case ProductTestingTypes.GET_JOB_LIST.ERROR:
      return {
        ...state,
        jobList: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_JOB_DETAIL
    case ProductTestingTypes.GET_JOB_DETAIL.LOADING:
      return {
        ...state,
        jobDetail: {
          ...state.jobDetail,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_JOB_DETAIL.SUCCESS:
      return {
        ...state,
        jobDetail: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.GET_JOB_DETAIL.ERROR:
      return {
        ...state,
        jobDetail: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_QUOTE_LIST_JOB_DETAIL
    case ProductTestingTypes.GET_QUOTE_LIST_JOB_DETAIL.LOADING:
      return {
        ...state,
        quoteListJobDetail: {
          ...state.quoteListJobDetail,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_QUOTE_LIST_JOB_DETAIL.SUCCESS:
      return {
        ...state,
        quoteListJobDetail: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.GET_QUOTE_LIST_JOB_DETAIL.ERROR:
      return {
        ...state,
        quoteListJobDetail: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_QUOTE_DETAIL_JOB_DETAIL
    case ProductTestingTypes.GET_QUOTE_DETAIL_JOB_DETAIL.LOADING:
      return {
        ...state,
        quoteDetailJobDetail: {
          ...state.quoteDetailJobDetail,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_QUOTE_DETAIL_JOB_DETAIL.SUCCESS:
      return {
        ...state,
        quoteDetailJobDetail: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.GET_QUOTE_DETAIL_JOB_DETAIL.ERROR:
      return {
        ...state,
        quoteDetailJobDetail: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_REPORT_LIST_JOB_DETAIL
    case ProductTestingTypes.GET_REPORT_LIST_JOB_DETAIL.LOADING:
      return {
        ...state,
        reportListJobDetail: {
          ...state.reportListJobDetail,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_REPORT_LIST_JOB_DETAIL.SUCCESS:
      return {
        ...state,
        reportListJobDetail: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.GET_REPORT_LIST_JOB_DETAIL.ERROR:
      return {
        ...state,
        reportListJobDetail: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_REPORT_DETAIL_JOB_DETAIL
    case ProductTestingTypes.GET_REPORT_DETAIL_JOB_DETAIL.LOADING:
      return {
        ...state,
        reportDetailJobDetail: {
          ...state.reportDetailJobDetail,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_REPORT_DETAIL_JOB_DETAIL.SUCCESS:
      return {
        ...state,
        reportDetailJobDetail: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.GET_REPORT_DETAIL_JOB_DETAIL.ERROR:
      return {
        ...state,
        reportDetailJobDetail: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_FAILURE_RECORD_LIST_JOB_DETAIL
    case ProductTestingTypes.GET_FAILURE_RECORD_LIST_JOB_DETAIL.LOADING:
      return {
        ...state,
        failureRecordListJobDetail: {
          ...state.reportListJobDetail,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_FAILURE_RECORD_LIST_JOB_DETAIL.SUCCESS:
      return {
        ...state,
        failureRecordListJobDetail: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.GET_FAILURE_RECORD_LIST_JOB_DETAIL.ERROR:
      return {
        ...state,
        failureRecordListJobDetail: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_FAILURE_RECORD_DETAIL_JOB_DETAIL
    case ProductTestingTypes.GET_FAILURE_RECORD_DETAIL_JOB_DETAIL.LOADING:
      return {
        ...state,
        failureRecordDetailJobDetail: {
          ...state.failureRecordDetailJobDetail,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_FAILURE_RECORD_DETAIL_JOB_DETAIL.SUCCESS:
      return {
        ...state,
        failureRecordDetailJobDetail: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.GET_FAILURE_RECORD_DETAIL_JOB_DETAIL.ERROR:
      return {
        ...state,
        failureRecordDetailJobDetail: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_ATTACHMENT_LIST_JOB_DETAIL
    case ProductTestingTypes.GET_ATTACHMENT_LIST_JOB_DETAIL.LOADING:
      return {
        ...state,
        attachmentsJobDetail: {
          ...state.attachmentsJobDetail,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_ATTACHMENT_LIST_JOB_DETAIL.SUCCESS:
      return {
        ...state,
        attachmentsJobDetail: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.GET_ATTACHMENT_LIST_JOB_DETAIL.ERROR:
      return {
        ...state,
        attachmentsJobDetail: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_INVOICE_JOB_DETAIL
    case ProductTestingTypes.GET_INVOICE_JOB_DETAIL.LOADING:
      return {
        ...state,
        invoiceJobDetail: {
          ...state.invoiceJobDetail,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_INVOICE_JOB_DETAIL.SUCCESS:
      return {
        ...state,
        invoiceJobDetail: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.GET_INVOICE_JOB_DETAIL.ERROR:
      return {
        ...state,
        invoiceJobDetail: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_INVOICE_LIST_JOB_DETAIL
    case ProductTestingTypes.GET_INVOICE_LIST_JOB_DETAIL.LOADING:
      return {
        ...state,
        invoicesJobDetail: {
          ...state.invoicesJobDetail,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_INVOICE_LIST_JOB_DETAIL.SUCCESS:
      return {
        ...state,
        invoicesJobDetail: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.GET_INVOICE_LIST_JOB_DETAIL.ERROR:
      return {
        ...state,
        invoicesJobDetail: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_LOG_LIST_JOB_DETAIL
    case ProductTestingTypes.GET_LOG_LIST_JOB_DETAIL.LOADING:
      return {
        ...state,
        logListJobDetail: {
          ...state.logListJobDetail,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_LOG_LIST_JOB_DETAIL.SUCCESS:
      return {
        ...state,
        logListJobDetail: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.GET_LOG_LIST_JOB_DETAIL.ERROR:
      return {
        ...state,
        logListJobDetail: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_TAG_LIST_JOB_DETAIL
    case ProductTestingTypes.GET_TAG_LIST_JOB_DETAIL.LOADING:
      return {
        ...state,
        tagListJobDetail: {
          ...state.tagListJobDetail,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_TAG_LIST_JOB_DETAIL.SUCCESS:
      return {
        ...state,
        tagListJobDetail: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.GET_TAG_LIST_JOB_DETAIL.ERROR:
      return {
        ...state,
        tagListJobDetail: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_PRODUCT_LIST
    case ProductTestingTypes.GET_PRODUCT_LIST.LOADING:
      return {
        ...state,
        productList: {
          ...state.productList,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_PRODUCT_LIST.SUCCESS:
      return {
        ...state,
        productList: {
          loading: false,
          data: action.payload,
          total: action.total,
          error: null,
        },
      };
    case ProductTestingTypes.GET_PRODUCT_LIST.ERROR:
      return {
        ...state,
        productList: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_SUPPLIER_LIST
    case ProductTestingTypes.GET_SUPPLIER_LIST.LOADING:
      return {
        ...state,
        supplierList: {
          ...state.supplierList,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_SUPPLIER_LIST.SUCCESS:
      return {
        ...state,
        supplierList: {
          loading: false,
          data: action.payload,
          total: action.total,
          error: null,
        },
      };
    case ProductTestingTypes.GET_SUPPLIER_LIST.ERROR:
      return {
        ...state,
        supplierList: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_TAG_LIST
    case ProductTestingTypes.GET_TAG_LIST.LOADING:
      return {
        ...state,
        tagList: {
          ...state.tagList,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_TAG_LIST.SUCCESS:
      return {
        ...state,
        tagList: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.GET_TAG_LIST.ERROR:
      return {
        ...state,
        tagList: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_LAB_LIST
    case ProductTestingTypes.GET_LAB_LIST.LOADING:
      return {
        ...state,
        labList: {
          ...state.labList,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_LAB_LIST.SUCCESS:
      return {
        ...state,
        labList: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.GET_LAB_LIST.ERROR:
      return {
        ...state,
        labList: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_LAB_LIST
    case ProductTestingTypes.GET_LAB_OPTIONAL_LIST.LOADING:
      return {
        ...state,
        labOptionalList: {
          ...state.labOptionalList,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_LAB_OPTIONAL_LIST.SUCCESS:
      return {
        ...state,
        labOptionalList: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.GET_LAB_OPTIONAL_LIST.ERROR:
      return {
        ...state,
        labOptionalList: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_REPORT_LAB_LIST
    case ProductTestingTypes.GET_REPORT_LAB_LIST.LOADING:
      return {
        ...state,
        reportLabList: {
          ...state.reportLabList,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_REPORT_LAB_LIST.SUCCESS:
      return {
        ...state,
        reportLabList: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.GET_REPORT_LAB_LIST.ERROR:
      return {
        ...state,
        reportLabList: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_REPORT_CITATION_LIST
    case ProductTestingTypes.GET_REPORT_CITATION_LIST.LOADING:
      return {
        ...state,
        reportCitationList: {
          ...state.reportCitationList,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_REPORT_CITATION_LIST.SUCCESS:
      return {
        ...state,
        reportCitationList: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.GET_REPORT_CITATION_LIST.ERROR:
      return {
        ...state,
        reportCitationList: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_REPORT_TEST_ITEM_LIST
    case ProductTestingTypes.GET_REPORT_TEST_ITEM_LIST.LOADING:
      return {
        ...state,
        reportTestItemList: {
          ...state.reportTestItemList,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_REPORT_TEST_ITEM_LIST.SUCCESS:
      return {
        ...state,
        reportTestItemList: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.GET_REPORT_TEST_ITEM_LIST.ERROR:
      return {
        ...state,
        reportTestItemList: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_SERVICE_PROVIDER
    case ProductTestingTypes.GET_SERVICE_PROVIDER.LOADING:
      return {
        ...state,
        serviceProvider: {
          ...state.serviceProvider,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_SERVICE_PROVIDER.SUCCESS:
      return {
        ...state,
        serviceProvider: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.GET_SERVICE_PROVIDER.ERROR:
      return {
        ...state,
        serviceProvider: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_ANALYTICS_DATA
    case ProductTestingTypes.GET_ANALYTICS_DATA.LOADING:
      return {
        ...state,
        analyticsData: {
          ...state.analyticsData,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_ANALYTICS_DATA.SUCCESS:
      return {
        ...state,
        analyticsData: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.GET_ANALYTICS_DATA.ERROR:
      return {
        ...state,
        analyticsData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // GET_QUOTE_TEST_ITEM_LIST
    case ProductTestingTypes.GET_QUOTE_TEST_ITEM_LIST.LOADING:
      return {
        ...state,
        quoteTestItemList: {
          ...state.quoteTestItemList,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.GET_QUOTE_TEST_ITEM_LIST.SUCCESS:
      return {
        ...state,
        quoteTestItemList: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.GET_QUOTE_TEST_ITEM_LIST.ERROR:
      return {
        ...state,
        quoteTestItemList: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // CREATE_JOB
    case ProductTestingTypes.CREATE_JOB.LOADING:
      return {
        ...state,
        createJob: {
          data: {},
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.CREATE_JOB.SUCCESS:
      return {
        ...state,
        createJob: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.CREATE_JOB.ERROR:
      return {
        ...state,
        createJob: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // DUPLICATE_JOB
    case ProductTestingTypes.DUPLICATE_JOB.LOADING:
      return {
        ...state,
        duplicateJob: {
          data: {},
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.DUPLICATE_JOB.SUCCESS:
      return {
        ...state,
        duplicateJob: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.DUPLICATE_JOB.ERROR:
      return {
        ...state,
        duplicateJob: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // UPDATE_JOB_DETAIL
    case ProductTestingTypes.UPDATE_JOB_DETAIL.LOADING:
      return {
        ...state,
        jobDetail: {
          ...state.jobDetail,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.UPDATE_JOB_DETAIL.SUCCESS:
      return {
        ...state,
        jobDetail: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.UPDATE_JOB_DETAIL.ERROR:
      return {
        ...state,
        jobDetail: {
          ...state.jobDetail,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // UPDATE_ADMIN_STATUS_JOB_DETAIL
    case ProductTestingTypes.UPDATE_ADMIN_STATUS_JOB_DETAIL.LOADING:
      return {
        ...state,
        jobDetail: {
          ...state.jobDetail,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.UPDATE_ADMIN_STATUS_JOB_DETAIL.SUCCESS:
      return {
        ...state,
        jobDetail: {
          loading: false,
          data: {
            ...state.jobDetail.data,
            status: action.payload,
          },
          error: null,
        },
      };
    case ProductTestingTypes.UPDATE_ADMIN_STATUS_JOB_DETAIL.ERROR:
      return {
        ...state,
        jobDetail: {
          ...state.jobDetail,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // UPDATE_LINKAGE
    case ProductTestingTypes.UPDATE_LINKAGE.LOADING:
      return {
        ...state,
        updateLinkage: {
          data: {},
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.UPDATE_LINKAGE.SUCCESS:
      return {
        ...state,
        updateLinkage: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.UPDATE_LINKAGE.ERROR:
      return {
        ...state,
        updateLinkage: {
          ...state.updateLinkage,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // CREATE_QUOTE
    case ProductTestingTypes.CREATE_QUOTE.LOADING:
      return {
        ...state,
        createQuote: {
          data: {},
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.CREATE_QUOTE.SUCCESS:
      return {
        ...state,
        createQuote: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.CREATE_QUOTE.ERROR:
      return {
        ...state,
        createQuote: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // UPDATE_QUOTE
    case ProductTestingTypes.UPDATE_QUOTE.LOADING:
      return {
        ...state,
        updateQuote: {
          data: {},
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.UPDATE_QUOTE.SUCCESS:
      return {
        ...state,
        updateQuote: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.UPDATE_QUOTE.ERROR:
      return {
        ...state,
        updateQuote: {
          ...state.updateQuote,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // CREATE_REPORT
    case ProductTestingTypes.CREATE_REPORT.LOADING:
      return {
        ...state,
        createReport: {
          data: {},
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.CREATE_REPORT.SUCCESS:
      return {
        ...state,
        createReport: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.CREATE_REPORT.ERROR:
      return {
        ...state,
        createReport: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // UPDATE_REPORT
    case ProductTestingTypes.UPDATE_REPORT.LOADING:
      return {
        ...state,
        updateReport: {
          data: {},
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.UPDATE_REPORT.SUCCESS:
      return {
        ...state,
        updateReport: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.UPDATE_REPORT.ERROR:
      return {
        ...state,
        updateReport: {
          ...state.updateReport,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // DELETE_REPORT
    case ProductTestingTypes.DELETE_REPORT.LOADING:
      return {
        ...state,
        reportListJobDetail: {
          ...state.reportListJobDetail,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.DELETE_REPORT.SUCCESS: {
      const removedReportId = Number(action.payload);
      const newList = get(state, 'reportListJobDetail.data.list', []).filter(
        (item) => item.id !== removedReportId
      );
      return {
        ...state,
        reportListJobDetail: {
          loading: false,
          data: { ...get(state, 'reportListJobDetail.data'), list: newList },
          error: null,
        },
      };
    }
    case ProductTestingTypes.DELETE_REPORT.ERROR:
      return {
        ...state,
        reportListJobDetail: {
          ...state.reportListJobDetail,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // CREATE_FAILURE_RECORD
    case ProductTestingTypes.CREATE_FAILURE_RECORD.LOADING:
      return {
        ...state,
        createFailureRecord: {
          data: {},
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.CREATE_FAILURE_RECORD.SUCCESS:
      return {
        ...state,
        createFailureRecord: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.CREATE_FAILURE_RECORD.ERROR:
      return {
        ...state,
        createFailureRecord: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // UPDATE_FAILURE_RECORD
    case ProductTestingTypes.UPDATE_FAILURE_RECORD.LOADING:
      return {
        ...state,
        updateFailureRecord: {
          data: {},
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.UPDATE_FAILURE_RECORD.SUCCESS:
      return {
        ...state,
        updateFailureRecord: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.UPDATE_FAILURE_RECORD.ERROR:
      return {
        ...state,
        updateFailureRecord: {
          ...state.updateReport,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // DELETE_FAILURE_RECORD
    case ProductTestingTypes.DELETE_FAILURE_RECORD.LOADING:
      return {
        ...state,
        failureRecordListJobDetail: {
          ...state.failureRecordListJobDetail,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.DELETE_FAILURE_RECORD.SUCCESS: {
      const removedFailureRecordId = Number(action.payload);
      const newList = get(state, 'failureRecordListJobDetail.data.list', []).filter(
        (item) => item.id !== removedFailureRecordId
      );
      return {
        ...state,
        failureRecordListJobDetail: {
          loading: false,
          data: { ...get(state, 'failureRecordListJobDetail.data'), list: newList },
          error: null,
        },
      };
    }
    case ProductTestingTypes.DELETE_FAILURE_RECORD.ERROR:
      return {
        ...state,
        failureRecordListJobDetail: {
          ...state.failureRecordListJobDetail,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // ADD_ATTACHMENT_JOB_DETAIL
    case ProductTestingTypes.ADD_ATTACHMENT_JOB_DETAIL.LOADING:
      return {
        ...state,
        attachmentsJobDetail: {
          ...state.attachmentsJobDetail,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.ADD_ATTACHMENT_JOB_DETAIL.SUCCESS: {
      const newAttachmentData = { ...state.attachmentsJobDetail, ...action.payload };

      return {
        ...state,
        attachmentsJobDetail: {
          loading: false,
          data: { ...newAttachmentData },
          error: null,
        },
      };
    }
    case ProductTestingTypes.ADD_ATTACHMENT_JOB_DETAIL.ERROR:
      return {
        ...state,
        attachmentsJobDetail: {
          ...state.attachmentsJobDetail,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // DELETE_ATTACHMENT_JOB_DETAIL
    case ProductTestingTypes.DELETE_ATTACHMENT_JOB_DETAIL.LOADING:
      return {
        ...state,
        attachmentsJobDetail: {
          ...state.attachmentsJobDetail,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.DELETE_ATTACHMENT_JOB_DETAIL.SUCCESS: {
      const removedAttachmentId = Number(action.payload);
      const attachmentData = get(state, 'attachmentsJobDetail.data', {});
      const newList = get(attachmentData, 'list', []).filter(
        (item) => item.id !== removedAttachmentId
      );
      const totalNo =
        get(attachmentData, 'totalNo', 0) > 1 ? get(attachmentData, 'totalNo') - 1 : 0;

      return {
        ...state,
        attachmentsJobDetail: {
          loading: false,
          data: {
            ...attachmentData,
            list: newList,
            totalNo,
          },
          error: null,
        },
      };
    }
    case ProductTestingTypes.DELETE_ATTACHMENT_JOB_DETAIL.ERROR:
      return {
        ...state,
        attachmentsJobDetail: {
          ...state.attachmentsJobDetail,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // ADD_INVOICE_JOB_DETAIL
    case ProductTestingTypes.ADD_INVOICE_JOB_DETAIL.LOADING:
      return {
        ...state,
        invoicesJobDetail: {
          ...state.invoicesJobDetail,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.ADD_INVOICE_JOB_DETAIL.SUCCESS: {
      // const newInvoiceList = action.payload;
      // const newList = [...newInvoiceList, ...get(state, 'invoicesJobDetail.data.list', [])];
      return {
        ...state,
        invoicesJobDetail: {
          loading: false,
          data: action.payload, // { ...state.invoicesJobDetail.data, list: newList },
          error: null,
        },
      };
    }
    case ProductTestingTypes.ADD_INVOICE_JOB_DETAIL.ERROR:
      return {
        ...state,
        invoicesJobDetail: {
          ...state.invoicesJobDetail,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // UPDATE_INVOICE_JOB_DETAIL
    case ProductTestingTypes.UPDATE_INVOICE_JOB_DETAIL.LOADING:
      return {
        ...state,
        invoicesJobDetail: {
          ...state.invoicesJobDetail,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.UPDATE_INVOICE_JOB_DETAIL.SUCCESS: {
      return {
        ...state,
        invoicesJobDetail: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    }
    case ProductTestingTypes.UPDATE_INVOICE_JOB_DETAIL.ERROR:
      return {
        ...state,
        invoicesJobDetail: {
          ...state.invoicesJobDetail,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // DELETE_INVOICE_JOB_DETAIL
    case ProductTestingTypes.DELETE_INVOICE_JOB_DETAIL.LOADING:
      return {
        ...state,
        invoicesJobDetail: {
          ...state.invoicesJobDetail,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.DELETE_INVOICE_JOB_DETAIL.SUCCESS: {
      const removedInvoiceId = Number(action.payload);
      const newList = get(state, 'invoicesJobDetail.data.list', []).filter(
        (item) => item.id !== removedInvoiceId
      );
      return {
        ...state,
        invoicesJobDetail: {
          loading: false,
          data: { ...state.invoicesJobDetail.data, list: newList },
          error: null,
        },
      };
    }
    case ProductTestingTypes.DELETE_INVOICE_JOB_DETAIL.ERROR:
      return {
        ...state,
        invoicesJobDetail: {
          ...state.invoicesJobDetail,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // ADD_TAG_JOB_DETAIL
    case ProductTestingTypes.ADD_TAG_JOB_DETAIL.LOADING:
      return {
        ...state,
        tagListJobDetail: {
          ...state.tagListJobDetail,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.ADD_TAG_JOB_DETAIL.SUCCESS:
      return {
        ...state,
        tagListJobDetail: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.ADD_TAG_JOB_DETAIL.ERROR:
      return {
        ...state,
        tagListJobDetail: {
          ...state.tagListJobDetail,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // DELETE_TAG_JOB_DETAIL
    case ProductTestingTypes.DELETE_TAG_JOB_DETAIL.LOADING:
      return {
        ...state,
        tagListJobDetail: {
          ...state.tagListJobDetail,
          loading: true,
          error: null,
        },
      };
    case ProductTestingTypes.DELETE_TAG_JOB_DETAIL.SUCCESS:
      return {
        ...state,
        tagListJobDetail: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.DELETE_TAG_JOB_DETAIL.ERROR:
      return {
        ...state,
        tagListJobDetail: {
          ...state.tagListJobDetail,
          loading: false,
          error: action.payload,
        },
      };

    //-------------------------------------------------
    // DOWNLOAD_QUOTE_DOCUMENTS_JOB_DETAIL
    case ProductTestingTypes.DOWNLOAD_QUOTE_DOCUMENTS_JOB_DETAIL.LOADING:
      return {
        ...state,
        quoteDocumentsDownloadedJobDetail: {
          loading: true,
          data: {},
          error: null,
        },
      };
    case ProductTestingTypes.DOWNLOAD_QUOTE_DOCUMENTS_JOB_DETAIL.SUCCESS:
      return {
        ...state,
        quoteDocumentsDownloadedJobDetail: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.DOWNLOAD_QUOTE_DOCUMENTS_JOB_DETAIL.ERROR:
      return {
        ...state,
        quoteDocumentsDownloadedJobDetail: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    case ProductTestingTypes.DOWNLOAD_QUOTE_DOCUMENTS_JOB_DETAIL.RESET:
      return {
        ...state,
        quoteDocumentsDownloadedJobDetail: INITIAL_STATE.quoteDocumentsDownloadedJobDetail,
      };

    //-------------------------------------------------
    // DOWNLOAD_REPORT_LIST_JOB_DETAIL
    case ProductTestingTypes.DOWNLOAD_REPORT_LIST_JOB_DETAIL.LOADING:
      return {
        ...state,
        reportDownloadedListJobDetail: {
          loading: true,
          data: {},
          error: null,
        },
      };
    case ProductTestingTypes.DOWNLOAD_REPORT_LIST_JOB_DETAIL.SUCCESS:
      return {
        ...state,
        reportDownloadedListJobDetail: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.DOWNLOAD_REPORT_LIST_JOB_DETAIL.ERROR:
      return {
        ...state,
        reportDownloadedListJobDetail: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    case ProductTestingTypes.DOWNLOAD_REPORT_LIST_JOB_DETAIL.RESET:
      return {
        ...state,
        reportDownloadedListJobDetail: INITIAL_STATE.reportDownloadedListJobDetail,
      };

    //-------------------------------------------------
    // DOWNLOAD_ATTACHMENT_LIST_JOB_DETAIL
    case ProductTestingTypes.DOWNLOAD_ATTACHMENT_LIST_JOB_DETAIL.LOADING:
      return {
        ...state,
        attachmentDownloadedListJobDetail: {
          loading: true,
          data: {},
          error: null,
        },
      };
    case ProductTestingTypes.DOWNLOAD_ATTACHMENT_LIST_JOB_DETAIL.SUCCESS:
      return {
        ...state,
        attachmentDownloadedListJobDetail: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.DOWNLOAD_ATTACHMENT_LIST_JOB_DETAIL.ERROR:
      return {
        ...state,
        attachmentDownloadedListJobDetail: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    case ProductTestingTypes.DOWNLOAD_ATTACHMENT_LIST_JOB_DETAIL.RESET:
      return {
        ...state,
        attachmentDownloadedListJobDetail: INITIAL_STATE.attachmentDownloadedListJobDetail,
      };

    //-------------------------------------------------
    // DOWNLOAD_INVOICE_LIST_JOB_DETAIL
    case ProductTestingTypes.DOWNLOAD_INVOICE_LIST_JOB_DETAIL.LOADING:
      return {
        ...state,
        invoiceDownloadedListJobDetail: {
          loading: true,
          data: {},
          error: null,
        },
      };
    case ProductTestingTypes.DOWNLOAD_INVOICE_LIST_JOB_DETAIL.SUCCESS:
      return {
        ...state,
        invoiceDownloadedListJobDetail: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.DOWNLOAD_INVOICE_LIST_JOB_DETAIL.ERROR:
      return {
        ...state,
        invoiceDownloadedListJobDetail: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    case ProductTestingTypes.DOWNLOAD_INVOICE_LIST_JOB_DETAIL.RESET:
      return {
        ...state,
        invoiceDownloadedListJobDetail: INITIAL_STATE.invoiceDownloadedListJobDetail,
      };

    case ProductTestingTypes.GET_SHARE_REPORT.LOADING:
      return {
        ...state,
        shareReportList: {
          loading: true,
          data: [],
          error: null,
        },
      };
    case ProductTestingTypes.GET_SHARE_REPORT.SUCCESS:
      return {
        ...state,
        shareReportList: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case ProductTestingTypes.GET_SHARE_REPORT.ERROR:
      return {
        ...state,
        shareReportList: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };

    //-------------------------------------------------
    default:
      return state;
  }
}
